module.exports = __webpack_public_path__ + "img/keypoint.506e21e0.svg";